import React from 'react';

import ChainIcon from '@/components/ChainIcon';
import { Badge } from '@/components/shadcn/ui/badge';
import { Currency } from '@/constants';
import useTokenIconByCurrency from '@/hooks/useChainIconByCurrency';
import useExplorerByCurrency from '@/hooks/useExplorerByCurrency';
import { truncateMidAddressInputValue } from '@/utils';

const BuildDetailsCwebExplorerLink: React.FC<{
  id: string;
}> = ({ id }) => {
  const explorerLink = useExplorerByCurrency(Currency.CWEB);
  const { icon } = useTokenIconByCurrency(Currency.CWEB);

  if (!id) return null;

  return (
    explorerLink && (
      <a href={`${explorerLink}?search=${id}`} target="_blank" rel="noopener noreferrer">
        <Badge className="cursor-pointer gap-1">
          <ChainIcon noBackground src={icon || ''} className="size-3 p-0" />
          {truncateMidAddressInputValue(id)}
        </Badge>
      </a>
    )
  );
};

export default BuildDetailsCwebExplorerLink;
